import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import React from 'react';
import { createSelector } from 'reselect';
import CloseIcon from '@material-ui/icons/Close';
import Input from '@material-ui/core/Input';
import RiverFilterButton from '../../button/RiverFilterButton';

interface IRiverFilterSelectorProps {
    id ?: string;
    fullWidth ?: boolean;
    required ?: boolean;

    label : string;
    disabled ?: boolean;

    name : string | null;
    code : string | null;
    division : string | null;

    onChange ?: (name : string | null, code : string | null, division : string | null) => void;
}

interface IRiverFilterSelectorState {
    open : boolean;
}

export default class RiverFilterSelector extends React.PureComponent<IRiverFilterSelectorProps, IRiverFilterSelectorState> {
    constructor(props : IRiverFilterSelectorProps) {
        super(props);
        this.state = {
            open: false,
        };
    }

    private readonly onFilterIconButtonClick = () => {
        this.toggleOpen(!this.state.open);
    };

    private readonly onFilterFocusClick = () => {
        this.toggleOpen(true);
    };

    private readonly onClearClick = () => {
        this.onChange(null, null, null);
    };

    public readonly onChange = (name : string | null, code : string | null, division : string | null) => {
        this.setState({
            open: false,
        });

        if (!this.props.onChange) return;
        this.props.onChange(name, code, division);

    };

    private readonly toggleOpen = (open : boolean) => {
        this.setState({
            open,
        });
    };

    private readonly getName = (props : IRiverFilterSelectorProps) => props.name;
    private readonly getCode = (props : IRiverFilterSelectorProps) => props.code;
    private readonly getDivision = (props : IRiverFilterSelectorProps) => props.division;
    private readonly getLabel = createSelector(
        [this.getName, this.getCode, this.getDivision],
        (name, code, division) => {
            const result = [];

            if (name) result.push(name);
            if (code) result.push(code);
            if (division) result.push(division);

            return result.join(' - ');
        },
    );

    public readonly render = () => {
        const { required, fullWidth, label, id, name, code, division, disabled } = this.props;
        const { open } = this.state;

        const value = this.getLabel(this.props);
        return (
            <FormControl fullWidth={fullWidth} error={required && !code} required={required}>
                <InputLabel htmlFor={id}>{label}</InputLabel>
                <Input
                    onFocus={this.onFilterFocusClick}
                    onChange={undefined}
                    value={value}
                    readOnly
                    endAdornment={
                        <InputAdornment position='end'>
                            {
                                (code || name || division) &&
                                <IconButton
                                    aria-label='clear filter'
                                    onClick={this.onClearClick}
                                >
                                    <CloseIcon className='cr' />
                                </IconButton>
                            }
                            <RiverFilterButton
                                color='primary'
                                id='Rivers_filter'
                                open={open}
                                onClick={this.onFilterIconButtonClick}
                                onChange={this.onChange}
                                name={name}
                                code={code}
                                division={division}
                                disabled={disabled}
                            />
                        </InputAdornment>
                    }
                />
            </FormControl>
        );
    };
}
